import { styled } from '@mui/material/styles';
import { JE_TABLE_CLASSES } from 'components/Tables/grid/StyledComponents';

export const JETableOverride = styled('div', {
  label: 'JETableOverride',
})(() => ({
  [`& .${JE_TABLE_CLASSES.COLGROUP_COL}`]: {
    width: '20%',
  },

  [`& .${JE_TABLE_CLASSES.ROW}`]: {
    backgroundColor: 'transparent',

    [`&:last-child .${JE_TABLE_CLASSES.CELL}:after`]: {
      display: 'none',
    },
  },

  [`& .${JE_TABLE_CLASSES.CELL}`]: {
    '&:after': {
      content: '""',
      position: 'absolute',
      display: 'block',
      top: '100%',
      left: 0,
      right: 0,
      borderBottom: '1px solid #DEE2E6',
    },
    '&:nth-child(4)': {
      '&:after': {
        display: 'none',
      },
    },
    '&:nth-child(5)': {
      textAlign: 'right',
      '&:after': {
        display: 'none',
      },
    },
  },
}));
